import { PU_TOAST_DEFAULT_CONFIG } from '@hglobal/common';

export const TOAST_DEFAULT_CONFIG = { ...PU_TOAST_DEFAULT_CONFIG, closeIconName: 'pu-close' };
